import { type ReactNode } from 'react'
import { Logo } from '@/components/ds/Logo'
import styles from './AuthLayout.module.scss'

interface AuthLayoutProps {
  /** Form content rendered inside the right-hand panel. */
  children: ReactNode
}

/**
 * Split-panel chrome shared by /login, /reset-password, and any future
 * unauth screen: brand pitch on the left (collapses below 960px), form on
 * the right. Pages plug their own form/inputs into `children`.
 */
export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className={styles.page}>
      <aside className={styles.brandPanel}>
        <div className={styles.brandTop}>
          <img src="/brand/prism-mark.svg" alt="" width={28} height={28} />
          <span className={styles.brandName}>Prism</span>
        </div>

        <div className={styles.brandMid}>
          <h2 className={styles.pitch}>
            A fábrica de <em>vídeos</em> que nunca dorme.
          </h2>
          <p className={styles.sub}>
            Pipeline completo: roteiro, voz, cortes, thumb e agendamento — em minutos.
            Multicanal. Multiformato. Em escala.
          </p>

          <div className={styles.stats}>
            <div className={styles.stat}>
              <div className={styles.statValue}>2.4k</div>
              <div className={styles.statLabel}>Vídeos · 30d</div>
            </div>
            <div className={styles.stat}>
              <div className={styles.statValue}>14</div>
              <div className={styles.statLabel}>Canais ativos</div>
            </div>
            <div className={styles.stat}>
              <div className={styles.statValue}>38M</div>
              <div className={styles.statLabel}>Views totais</div>
            </div>
          </div>
        </div>

        <div className={styles.brandFoot}>
          <span>© 2026 Prism Labs</span>
        </div>
      </aside>

      <main className={styles.formPanel}>
        <div className={styles.formTop}>
          <span className={styles.mobileBrand} aria-hidden>
            <Logo variant="full" size="md" />
          </span>
        </div>

        <div className={styles.formMid}>
          <div className={styles.formWrap}>{children}</div>
        </div>
      </main>
    </div>
  )
}
